import ACTIONS_TYPE from './actionType';
import { SRPStateInterface } from './srpInterface';

export const initialState = SRPStateInterface;
const SRPReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
  case ACTIONS_TYPE.SRP_LISTING_LOADING:
    return {
      ...state,
      loading: payload,
    };
  case ACTIONS_TYPE.GET_FILTERS:
    return {
      ...state,
      filters: payload,
    };
  case ACTIONS_TYPE.SET_APPLIED_FILTERS:
    return {
      ...state,
      appliedFilter: payload,
    };
  case ACTIONS_TYPE.GET_SRP_LISTING:
    return {
      ...state,
      listPartners: payload,
      loading: false,
    };
  case ACTIONS_TYPE.SET_TRANSLATION_TEXT:
    return {
      ...state,
      textToTranslate: [
        ...payload,
        ...(state?.textToTranslate?.length ? state.textToTranslate : []),
      ],
    };
  case ACTIONS_TYPE.SET_SORTING:
    return {
      ...state,
      sort_by: payload,
    };
  default:
    return {
      ...state,
    };
  }
};
export default SRPReducer;
